import { MessagingDetailsCard } from "@/components/atoms/interactionDetailsCard";
import { ChatMultiple20Regular } from "@fluentui/react-icons";
import { InteractionCardBase } from "./InteractionBase";
import { ChannelType } from "@/common/constants/shared";
import {
	acceptWebchatConversation,
	acceptWebchatConversationTransfer,
	rejectWebchatConversation,
	rejectWebchatConversationTransfer,
} from "@/repository/queryFns";

const webchatConfig = {
	icon: <ChatMultiple20Regular />,
	detailsCard: MessagingDetailsCard,
	acceptFn: acceptWebchatConversation,
	acceptTransferFn: acceptWebchatConversationTransfer,
	rejectFn: rejectWebchatConversation,
	rejectTransferFn: rejectWebchatConversationTransfer,
	messageIntlId: "Interaction.Contents.WebchatMessage",
};

export const WebchatInteractionCard = () => {
	return (
		<InteractionCardBase
			channelType={ChannelType.Webchat}
			channelConfig={webchatConfig}
		/>
	);
};
